const state = {
  cart: [],
  cartDialogFlag: false
}
export default state
